import {Product} from './product';
import {Company} from './company';

export class PartnerApiKeyAddModel {
  public comment: string;
  public permissions: string;
  public companyId: number;
  public apiKeyType: PartnerApiKeyType;
}

export class PartnerApiKey extends PartnerApiKeyAddModel {
  public isEnabled: boolean;
  public createdAt: Date;
  public apiKeyId: string;
  public apiKeyType: PartnerApiKeyType;
}

export enum PartnerApiKeyType {
  Webservice = 0,
  PseudoAtm = 1
}

export class PartnerCounter {
  public year: number;
  public month: number;
  public code: string;
  public numberOfActions: number;
  public amount: number;
  public productId: number;
  public product: Product;
  public companyId: number;
  public company: Company;
}

